import * as React from 'react';
import Accordion from '@westwing/ui-kit/Accordion';
import template from '@westwing/ui-kit/template';
import * as Styled from './FAQ.styles';
import { useFAQBlock } from '@ids/context';
import Center from '@ids/components/Layout/Center';
import useIdsGaTracking from '@ids/hooks/useIdsGaTracking';
import Divider from '@ids/components/Layout/Divider';
import Skeleton from '@ids/components/Layout/Skeleton';

const FAQ = () => {
    const faqBlock = useFAQBlock();
    const { trackIdsEvent } = useIdsGaTracking();
    const isOpenRef = React.useRef<Set<string>>(new Set()); // using ref to prevent unnecessary rerender on open/close

    const handleFaqItemClick =
        ({ id, name }: { id: string; name: string }) =>
        () => {
            if (!isOpenRef.current.has(id)) {
                isOpenRef.current.add(id);
                trackIdsEvent({
                    action: 'Content interaction click',
                    label: `See FAQ answers - ${name}`,
                });
            }
        };

    if (!faqBlock) {
        return <Skeleton />;
    }

    return (
        <React.Fragment>
            <Styled.FAQSection data-testid="faq_block_section" id="faq-block">
                <Center>
                    <Styled.SectionHeading>{faqBlock?.title}</Styled.SectionHeading>
                </Center>
                {faqBlock?.faqItems?.map(({ id, name, question, answer }) => (
                    <Accordion
                        key={id}
                        testId="faq_block_item"
                        renderTitle={() => <Styled.Question>{question}</Styled.Question>}
                        clickHandler={handleFaqItemClick({ id, name })}
                    >
                        <Styled.Answer>
                            {/* eslint-disable-next-line react/no-danger */}
                            <p dangerouslySetInnerHTML={{ __html: template(answer) }} />
                        </Styled.Answer>
                    </Accordion>
                ))}
            </Styled.FAQSection>
            <Divider />
        </React.Fragment>
    );
};

export default FAQ;
